"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./NewMessageBar.scss");
var _globalComponentsLibrary = require("global-components-library");
var _reactI18next = require("react-i18next");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var NewMessageBar = function NewMessageBar(_ref) {
  var onAceptedChat = _ref.onAceptedChat,
    onSpam = _ref.onSpam,
    onUnassign = _ref.onUnassign,
    disabled = _ref.disabled;
  var _useTranslation = (0, _reactI18next.useTranslation)(['new-message-bar']),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-message-bar-conteiner"
  }, onSpam && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
    disabled: disabled,
    color: "secondary",
    onClick: onSpam
  }, t('spam')), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
    disabled: disabled,
    color: "primary",
    onClick: onAceptedChat
  }, t('reply')), onUnassign && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
    disabled: disabled,
    color: "secondary",
    onClick: onUnassign
  }, t('unassign')));
};
NewMessageBar.propTypes = {
  onSpam: _propTypes["default"].func,
  onAceptedChat: _propTypes["default"].func,
  onUnassign: _propTypes["default"].func
};
var _default = exports["default"] = NewMessageBar;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/NewMessageBar/NewMessageBar.js
// module id = 1423
// module chunks = 0